var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-container',{attrs:{"id":"app"}},[_c('el-header',[_vm._v("TCPING RESULT")]),_c('el-main',[_c('Home')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }